<nav class="pagination__nav" [attr.aria-label]="'pagination.navigation' | translate">
  <button
    hlmBtn
    type="button"
    variant="ghost"
    size="icon"
    class="pagination__arrow"
    [disabled]="!hasPrevious()"
    [attr.aria-label]="'pagination.previous' | translate"
    (click)="onPrevious()"
  >
    <ocp-themed-icon
      class="pagination__arrow-icon pagination__arrow-icon--left"
      name="chevron-left.svg"
      [size]="16"
    />
  </button>

  @for (page of visiblePages(); track page) {
    <span class="pagination__page" [attr.aria-current]="page === activeIndex() + 1 ? 'page' : null">
      <button
        hlmBtn
        type="button"
        variant="ghost"
        size="icon"
        class="pagination__page-btn"
        [class.pagination__page-btn--active]="page === activeIndex() + 1"
        [attr.aria-label]="('pagination.go-to-page' | translate) + ' ' + page"
        (click)="onPageClick(page)"
      >
        {{ page }}
      </button>
    </span>
  }

  <button
    hlmBtn
    type="button"
    variant="ghost"
    size="icon"
    class="pagination__arrow"
    [disabled]="!hasNext()"
    [attr.aria-label]="'pagination.next' | translate"
    (click)="onNext()"
  >
    <ocp-themed-icon
      class="pagination__arrow-icon pagination__arrow-icon--right"
      name="chevron-right.svg"
      [size]="16"
    />
  </button>
</nav>
